import React, { useEffect, useState } from "react";
import { InfoCircleOutlined, UserOutlined } from "@ant-design/icons";
import { Input, Tooltip, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AddProfesor from "./AddProfesor";
import "./ProfesoriModern.css";
import withErrorBoundary from "../../Components/withErrorComponent";
function ProfileElevi() {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const profesori = useSelector((state) => state.profesori);
  const user = useSelector((state) => state.user);
  const [profesoriDisplay, setProfesoriDisplay] = useState([]);
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState("");
  let inputHandler = (e) => {
    //convert input text to lower case
    var lowerCase = e.target?.value.toLowerCase();
    setInputValue(lowerCase);
  };
  useEffect(() => {
    setProfesoriDisplay([]);
    let array = profesori;
    setProfesoriDisplay(
      array
        .filter((el) => {
          if (inputValue === "") {
            return el;
          } else {
            let materiiName = "";
            materii.forEach((materie) => {
              if (el.selectedMaterii.includes(materie.id)) {
                materiiName += materie.numeMaterie + " " + materie.profil + " ";
              }
            });

            const searchString = (
              (el.prenume || "") +
              " " +
              (el.numeDeFamilie || "") +
              " " +
              (el.cnp || "") +
              " " +
              materiiName
            )
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "") // Elimină diacriticele
              .toLowerCase();

            return searchString.includes(
              inputValue
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "") // Elimină diacriticele
                .toLowerCase()
            );
          }
        })
        .sort((a, b) => {
          const nameA = ((a.numeDeFamilie || "") + (a.prenume || ""))
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          const nameB = ((b.numeDeFamilie || "") + (b.prenume || ""))
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

          return nameA < nameB ? -1 : 1;
        })
    );
  }, [profesori, inputValue]);

  const materii = useSelector((state) => state.materii);
  const clase = useSelector((state) => state.clase);

  // Function to get teacher initials
  const getTeacherInitials = (firstName, lastName) => {
    return (firstName?.charAt(0) || "") + (lastName?.charAt(0) || "");
  };

  // Function to categorize subject tags
  const getSubjectTagClass = (subjectName) => {
    const subject = subjectName?.toLowerCase();
    if (subject?.includes("primar") || subject?.includes("pregătitoare")) {
      return "subject-tag primary";
    } else if (subject?.includes("administrativ")) {
      return "subject-tag administrative";
    } else {
      return "subject-tag secondary";
    }
  };

  return (
    <div className="teachers-page">
      <div className="teachers-header">
        <h1 className="teachers-title">Profesori</h1>
        <p className="teachers-subtitle">
          Gestionează și vizualizează corpul didactic al școlii
        </p>
      </div>

      <AddProfesor
        open={open}
        setConfirmLoading={setConfirmLoading}
        confirmLoading={confirmLoading}
        setOpen={setOpen}
      />

      <div className="teachers-controls">
        <div className="teachers-search">
          <Input
            placeholder="Căutare după nume sau materie..."
            onChange={inputHandler}
            prefix={<UserOutlined className="site-form-item-icon" />}
            size="large"
          />
        </div>
        {user.type === "admin" && (
          <Button
            type="primary"
            onClick={() => setOpen(true)}
            className="add-teacher-btn"
            size="large"
          >
            Adaugă profesor nou
          </Button>
        )}
      </div>

      <div className="teachers-grid">
        {profesoriDisplay.map((prof) => {
          const teacherSubjects =
            prof.selectedMaterii
              ?.map((m) => {
                const materia = materii?.find((ma) => ma.id === m);
                return materia
                  ? `${materia.numeMaterie} ${materia.profil}`.trim()
                  : "";
              })
              .filter(Boolean) || [];

          // Găsește clasele unde profesorul este diriginte
          const diriginteLa =
            clase?.filter(
              (clasa) =>
                clasa.diriginte === prof.id || clasa.diriginte_step === prof.id
            ) || [];

          // Găsește clasele unde profesorul predă
          const clasePredare =
            clase?.filter((clasa) =>
              clasa.materii?.some((materie) =>
                materie.profesori?.includes(prof.id)
              )
            ) || [];

          return (
            <div
              key={prof.id}
              className="modern-teacher-card"
              onClick={() => navigate(`/profesor/${prof.id}`)}
            >
              <div className="teacher-card-header">
                <div className="teacher-avatar">
                  {getTeacherInitials(prof.prenume, prof.numeDeFamilie)}
                </div>
                <div className="teacher-info">
                  <h3 className="teacher-name">
                    {prof.numeDeFamilie} {prof.prenume}
                  </h3>
                </div>
              </div>

              <div className="teacher-info-section">
                <div className="teacher-role-info">
                  {diriginteLa?.length > 0 ? (
                    <div className="diriginte-badge">
                      <span className="badge-icon">👨‍🏫</span>
                      <span>
                        Diriginte {diriginteLa[0].anClasa}
                        {diriginteLa[0].identificator}
                      </span>
                    </div>
                  ) : (
                    <div className="teacher-badge">
                      <span className="badge-icon">📚</span>
                      <span>Profesor</span>
                    </div>
                  )}
                </div>

                {clasePredare?.length > 0 && (
                  <div className="classe-info">
                    <span className="info-label">Predă la:</span>
                    <div className="class-tags">
                      {clasePredare.slice(0, 12).map((clasa) => (
                        <span key={clasa.id} className="class-tag">
                          {clasa.anClasa}
                          {clasa.identificator}
                        </span>
                      ))}
                      {clasePredare?.length > 12 && (
                        <span className="class-tag more">
                          +{clasePredare?.length - 12} mai multe
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {profesoriDisplay.length === 0 && inputValue && (
        <div className="teachers-empty">
          <div className="teachers-empty-icon">🔍</div>
          <div className="teachers-empty-title">Nu s-au găsit profesori</div>
          <div className="teachers-empty-description">
            Încercați să schimbați termenii de căutare
          </div>
        </div>
      )}
    </div>
  );
}

export default withErrorBoundary(ProfileElevi);
